import { ValidationType } from '../enums/validation-type.enum';

export const IesValidation = {
  duplicateSinApplicant: {
    property: 'socialInsuranceNumber',
    message: 'This Social Insurance Number has already been used on the Personal information page',
    type: ValidationType.Other,
  } as const,
  duplicateSinSpouse: {
    property: 'socialInsuranceNumber',
    message: 'This Social Insurance Number has already been used on the Spouse/Partner page',
    type: ValidationType.Other,
  } as const,
} as const;
